import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {EChartsOption} from 'echarts';
import {Constants} from '../../../shared/utils/constants';

@Component({
  selector: 'fx-portfolio-chart-base',
  templateUrl: './portfolio-chart-base.component.html',
  styleUrls: ['./portfolio-chart-base.component.sass'],
})
export class PortfolioChartBaseComponent implements OnInit, OnChanges {
  @Input()
  set channels(val) {
    this.channel = val;
    this.initChart();
  }
  @Input() currency: string;
  @Input() data: any;
  chartOption: EChartsOption;
  channel = 'EXCHANGES';
  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: any): void {
    if (changes.data && this.data) {
      setTimeout(() => {
        this.initChart();
      }, 1000);
    }
  }

  initChart(): void {
    if (this.data === undefined || Object.keys(this.data).length === 0) {
      return;
    }
    const getKeyDeposit = Object.keys(this.data).filter(f => f.indexOf('_deposit') > -1);
    const getKeyWithdraw = Object.keys(this.data).filter(f => f.indexOf('_withdraw') > -1);
    const mixDataDeposit = Constants[this.channel]
      .filter(f => getKeyDeposit.includes(f.value))
      .map(v => {
      const item = {
        value: this.data[v.value],
        text: v.name,
        itemStyle: { color: v.color },
      };
      return item;
    });
    const mixDataWithdraw = Constants[this.channel]
      .filter(f => getKeyWithdraw.includes(f.value))
      .map(v => {
      const item = {
        value: this.data[v.value],
        text: v.name,
        itemStyle: { color: v.color },
      };
      return item;
    });
    const series: any = [
      {
        data: mixDataDeposit,
        type: 'bar',
        barWidth: '30',
        barGap: '10%',
        barCategoryGap: '100%',
      },
      {
        data: mixDataWithdraw,
        type: 'bar',
        barWidth: '30',
        barGap: '10%',
        barCategoryGap: '100%',
      }
    ];
    this.chartOption = {
      textStyle: {
        fontFamily: 'Roboto Condensed'
      },
      tooltip: {
        formatter: (res) => {
          return res.data.text + ': ' + this.formatCurrency( this.currency, res.data.value);
        }
      },
      grid: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        show: false,
        containLabel: true,
      },
      xAxis: {
        type: 'category',
        splitLine: { show: false },
        axisTick: {
          show: false,
        },
        axisLine: {
          onZero: true,
          lineStyle: { color: '#3f3f50'},
        },
      },
      yAxis: {
        type: 'value',
        splitLine: { show: false },
        axisLabel: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
          lineStyle: { color: '#3f3f50' },
        },
      },
      series,
    };
  }
  private formatCurrency(curren, value): string {
    const formatter = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: curren
    });
    return formatter.format(value);
  }
}
